import * as Yup from "yup";
import {
    dateCantBeInFuture,
    dateIsBefore
} from "./validationFunctions";

export const informationToReleaseValidations = section => {
    if (section.active) {
        return Yup.object().shape({
            dosFrom1: section.fields.dosfrom.validations.required.value && Yup.date()
                .required(
                    () =>
                        'Please provide a service start date'
                ).nullable()
                .max(
                    dateCantBeInFuture,
                    'This date is in the future'
                )
                .test(
                    "dosfrom",
                    section.fields.dosfrom.validations.notFutureDate.message,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                ).test(
                    "afterBirthDate",
                    'Start date cannot be before birth date',
                    function () {
                        const { dosFrom1 } = this.parent;
                        const { PDOB1 } = this.parent;

                        if (dosFrom1 && PDOB1) {
                            return dateIsBefore(PDOB1, dosFrom1);
                        }
                    }
                ),

            dosTo1: section.fields.dosto.validations.required.value && Yup.date()
                .required(
                    () =>
                        'Please provide a service end date'
                ).nullable()
                .max(
                    dateCantBeInFuture,
                    'This date is in the future'
                )
                .test(
                    "afterFromDate",
                    'End date cannot be before start date',
                    function (dosTo1) {
                        const { dosFrom1 } = this.parent;
                        if (dosFrom1 && dosTo1) {
                            return dateIsBefore(dosFrom1, dosTo1);
                        }
                    }
                )
                .test(
                    "afterFromDate",
                    section.fields.dosto.validations.notFutureDate.message,
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                ),

            infoToReleaseGroup: section.fields.infoToReleaseGroup.validations.required.value && Yup.array().min(1,
                        "You must select at least one item for release"
                ),

            infoToReleaseGroupOther: Yup.string()
                .test(
                    "infoToReleaseGroupOther",
                    section.fields.infoToReleaseGroupOther.validations.required.message,
                    function (item) {

                        const { infoToReleaseGroup } = this.parent;
                        if (infoToReleaseGroup.includes("otherItem"))
                            return item && infoToReleaseGroup.includes("otherItem");
                        else return true;
                    }
                )
                .max(
                    section.fields.infoToReleaseGroupOther.validations.maxLength.value,
                    section.fields.infoToReleaseGroupOther.validations.maxLength.message
                ),

            requestPurposePdf: section.fields.infoToReleaseGroup.validations.required.value && Yup.string()
                .required(
                    () =>
                        "You must specify the purpose for the disclosure of medical records"
                ),
        });
    } else { return Yup.object().shape(); }
}
